import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCharities,
  createCharity,
  updateCharity,
  deleteCharity,
  getCharityByParam,
} from "./charitiesThunks";

const initialState = {
  items: [],
  selected: null,
  loading: false,
  error: null,
};

const charitiesSlice = createSlice({
  name: "charities",
  initialState,
  reducers: {
    clearSelected: state => {
      state.selected = null;
    },
  },
  extraReducers: builder => {
    builder
      // fetch all
      .addCase(fetchCharities.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCharities.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCharities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // create
      .addCase(createCharity.pending, state => {
        state.loading = true;
      })
      .addCase(createCharity.fulfilled, (state, action) => {
        state.loading = false;
        state.items.push(action.payload);
      })
      .addCase(createCharity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // update
      .addCase(updateCharity.pending, state => {
        state.loading = true;
      })
      .addCase(updateCharity.fulfilled, (state, action) => {
        state.loading = false;
        // update item in state.items if id matches
        const index = state.items.findIndex(i => i.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      .addCase(updateCharity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // delete
      .addCase(deleteCharity.pending, state => {
        state.loading = true;
      })
      .addCase(deleteCharity.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items.filter(i => i.id !== action.payload.id);
      })
      .addCase(deleteCharity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // get by param
      .addCase(getCharityByParam.pending, state => {
        state.loading = true;
      })
      .addCase(getCharityByParam.fulfilled, (state, action) => {
        state.loading = false;
        state.selected = action.payload;
      })
      .addCase(getCharityByParam.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearSelected } = charitiesSlice.actions;
export default charitiesSlice.reducer;
